(function ($) {
    $.extend(true, $, {
        fgt: {
            fb: function () {
                // Initialize our function calls and variables
                var $fbButton = $('.btn-facebook.ladda-button'),
                    laddaBtns = [];

                $fbButton.each(function() {
                    laddaBtns.push(new FG.Ladda(this));
                });

                function startLaddaBtns() {
                    $.each(laddaBtns, function(index, value) {
                        value.start();
                    });
                }

                function reportFbError(msg) {
                    var errorTitle = 'Facebook Error:'+window.location.hostname;
                    if (FGTLibs && FGTLibs.Bugsnag) {
                        var options = {
                            metaData: {
                                errorTitle: errorTitle,
                                errorMessage: msg,
                            },
                        };
                        FGTLibs.Bugsnag.client.notify('Facebook', options);
                    }
                }

                function stopLaddaBtns() {
                    $.each(laddaBtns, function(index, value) {
                        value.stop();
                    });
                }

                function login() {
                    var $signin = $('#signin'),
                        $errorDivs = $().add('#div-signin-error').add('#div-create-success');

                    startLaddaBtns();
                    $fbButton.attr('disabled', true);

                    // Brings up facebook login box and processes user response
                    FB.login(function (response) {
                        var accessToken, userId, expiresIn, db;

                        if (response.authResponse) {
                            accessToken = response.authResponse.accessToken; //get access token
                            userId = response.authResponse.userID, //get FB UID
                                expiresIn = response.authResponse.expiresIn;

                            db = new FG.DB();
                            db.set('facebookShortAccessToken', accessToken);
                            db.set('facebookShortAccessTokenExpiresIn', expiresIn);
                            FB.api('/me?fields=id,name,first_name,last_name,gender,locale,languages,link,age_range,timezone,updated_time,verified,birthday,currency,email,location,picture',

                                function (response) {
                                    //If we have an error, probably an OAuth error, return false, don't send to server
                                    if (response.status === 'not_authorized' || response.status === 'unknown') {
                                        reportFbError(response.status);
                                        return false;
                                    }

                                    response.accessToken = accessToken;
                                    response.expiresIn = expiresIn;

                                    var Ajax = new FG.AjaxJob('user/facebook_login');

                                    Ajax.setMessageDiv($errorDivs);

                                    Ajax.setRequestData(response);

                                    Ajax.setSuccessCallback(function (FGResponse) {
                                        var db = new FG.DB();

                                        db.set('picture', FGResponse.data.picture);
                                        db.set('firstName', FGResponse.data.firstName);
                                        db.set('activeWaitlistRequest', FGResponse.data.activeWaitlistRequest);

                                        //Set a login cookie
                                        $.cookie("FG_LOGGED_IN", 1, {
                                            path: '/'
                                        });

                                        //Set a login type cookie
                                        $.cookie("FG_LOGIN_TYPE", 'Facebook', {path: '/'});

                                        //Remove the custom cookie
                                        $.removeCookie('FG_CUSTOM', {
                                            path: '/'
                                        });

                                        setTimeout(function() {
                                            window.location.reload();
                                        }, 200);
                                    });

                                    Ajax.setFailureCallback(function (FGResponse) {
                                        $errorDivs.html(FGResponse.msg);
                                        $('.div-signin-error').html(FGResponse.msg).addClass('alert alert-warning').removeClass('hide');
                                        $fbButton.removeAttr('disabled');
                                        stopLaddaBtns();
                                    });

                                    Ajax.send();

                                });

                        } else {
                            stopLaddaBtns();
                            // User Cancelled Login or did not Fully Authorize
                            $fbButton.removeAttr('disabled');
                        }
                    }, {
                        scope: 'user_birthday,email,user_location,user_likes'
                    });

                    return false;
                }

                return {
                    // Run to initializing the script
                    init: function () {
                        // Load facebook api script
                        var e = document.createElement('script');
                        e.type = 'text/javascript';
                        e.src = document.location.protocol + '//connect.facebook.net/en_US/sdk.js';
                        e.async = true;
                        document.getElementById('fb-root').appendChild(e);

                        window.fbAsyncInit = function () {
                            FB.init({
                                appId: facebookAppId,
                                version: "v2.7",
                                status: false,
                                cookie: true,
                                xfbml: true
                            });
                        };

                        $fbButton.click(login);
                    }
                };
            }
        }
    });
})(jQuery);
